import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#home" },
  { label: "Vibecast", href: "#vibecast" },
  { label: "Vision", href: "#vision" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ease-out bg-zinc-950 text-white ${
        scrolled ? "border-b border-white/10 shadow-[0_4px_24px_-12px_rgba(0,0,0,0.6)]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#home"
          onClick={close}
          data-testid="navbar-logo"
          className="font-display text-[24px] font-extrabold tracking-[-0.03em] text-white flex items-center gap-2.5"
        >
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#0066FF] shadow-[0_0_12px_rgba(0,102,255,0.7)]" />
          <span className="leading-none">Laiv Ai</span>
        </a>

        <nav className="hidden md:flex items-center gap-8 ml-auto">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[15px] font-medium text-white/80 hover:text-white transition-colors duration-200 link-flourish"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="navbar-menu-toggle"
          className="md:hidden w-10 h-10 grid place-items-center rounded-full border border-white/15 text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-zinc-950 border-t border-white/10"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={close}
                className="text-base font-medium text-white/90 hover:text-white"
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
